module.exports = __webpack_public_path__ + "a0b4963c769c8f33f7beca7820055161.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/plantflask.svg
// module id = 25
// module chunks = 0 1